import React, { useMemo } from 'react';
import { ICompany } from '../../domain/company/interface';
import { ISite } from '../../domain/site/interface';
import { ICloudVen, ICustomerVen } from '../../domain/ven/interface';
import { VenInfo } from '../VenInfo/VenInfo';

interface ISiteVensInfo {
    site: ISite;
}

interface ISiteVenEntry {
    ven: ICustomerVen | ICloudVen;
    controlProvider?: ICompany | null;
}

// A customer ven scoped to a control provider should only show up on sites that belong to that same control provider.
const isVenVisibleOnSite = (ven: ICustomerVen, site: ISite): boolean =>
    !ven.control_provider_id || ven.control_provider_id === site.control_provider_id;

export const SiteVensInfo: React.FC<ISiteVensInfo> = ({ site }) => {
    const venEntries = useMemo<ISiteVenEntry[]>(() => {
        const customerVenEntries: ISiteVenEntry[] = [site.customer_ven, ...(site.company_customer_vens || [])]
            .filter((ven): ven is ICustomerVen => !!ven && isVenVisibleOnSite(ven, site))
            .map(ven => ({ ven, controlProvider: ven.control_provider_id ? site.control_provider : undefined }));

        const cloudVenEntries: ISiteVenEntry[] = (site.cloud_vens || []).map(ven => ({ ven }));

        return [...customerVenEntries, ...cloudVenEntries];
    }, [site]);

    if (venEntries.length === 0) return null;

    return (
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {venEntries.map(({ ven, controlProvider }) => (
                <VenInfo key={ven.id} ven={ven} controlProvider={controlProvider} />
            ))}
        </div>
    );
};
